module.exports = __webpack_public_path__ + "static/media/App2.d1b6e065.bin";